import { Asset } from '@websrc/App/Components/Asset/Asset'
import { Button } from '@websrc/App/Components/Button/Button'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { mapProductPage } from '@websrc/DataMappers/mapProductPage'
import React, { useState } from 'react'
import Masonry from 'react-responsive-masonry'

import { Lightbox } from '../Lightbox/Lightbox'
import { imageGrid } from './ImageGrid.css'

interface ImageGridProps {
  assets: ReturnType<typeof mapProductPage>['product_details']['assets']
}

export const ImageGrid: React.FC<ImageGridProps> = ({ assets }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [ligthboxSlideIndex, setLigthboxSlideIndex] = useState(0)
  const [showLightbox, setShowLightbox] = useState(false)
  const t = useStaticText()
  const THRESHOLD_IMAGE_COUNT = 5

  const showFewerImagesText = t.ecom.load_less_images
    ? t.ecom.load_less_images
    : 'Show fewer images'

  const showMoreImagesText = t.ecom.load_more_images ? t.ecom.load_more_images : 'Show more images'

  return (
    <>
      {Boolean(showLightbox) && (
        <Lightbox
          assets={assets}
          closeCallback={() => {
            setShowLightbox(false)
          }}
          initialSlideIndex={ligthboxSlideIndex}
        />
      )}

      <div className={imageGrid.container} data-testid={'image-grid'}>
        <div
          className={
            isExpanded || assets.length <= THRESHOLD_IMAGE_COUNT
              ? imageGrid.assetsList.expanded
              : imageGrid.assetsList.collapsed
          }
        >
          <Masonry columnsCount={2} gutter={'15px'}>
            {assets.map(({ thumbnail, video }, i) => (
              <div
                className={imageGrid.item}
                key={i}
                onClick={() => {
                  setShowLightbox(true)
                  setLigthboxSlideIndex(i)
                }}
              >
                <Asset
                  lazyLoading={true}
                  sizes={'(min-width: 1400px) 800px, (min-width: 1024px) 600px, 400px'}
                  srcSetWidths={[400, 600, 800, 1200, 1600]}
                  thumbnail={thumbnail}
                  video={video}
                  width={'100%'}
                />
              </div>
            ))}
          </Masonry>
        </div>
        {Boolean(assets.length > THRESHOLD_IMAGE_COUNT) && (
          <>
            <div
              className={
                isExpanded ? imageGrid.expandButtonBar.expanded : imageGrid.expandButtonBar.normal
              }
            >
              <Button
                color={'blue'}
                colorMode={'light'}
                iconName={isExpanded ? 'MINUS' : 'PLUS'}
                iconPosition={'left'}
                onClick={() => {
                  setIsExpanded((currIsExpanded) => !currIsExpanded)

                  if (isExpanded) {
                    window.scrollTo(0, 0)
                  }
                }}
                size={'medium'}
                text={isExpanded ? showFewerImagesText : showMoreImagesText}
                type={'secondary'}
              />
            </div>
          </>
        )}
      </div>
    </>
  )
}
